import $https from '@/servers/request'

/**
 * RAG 对话（同步返回）
 * @param {object} params
 * @param {string} params.message 用户问题
 * @param {string} params.sourceType 数据来源: article, image, all
 * @param {number} params.limit 返回数量
 * @param {number} params.similarityThreshold 相似度阈值
 * @param {string} params.conversationId 对话ID
 */
export const ragChatSync = (params) => {
  return $https.post('/ai/rag/chat/sync', params)
}

/**
 * RAG 对话 + 搜索结果（返回答案 + 可点击卡片列表）
 * @param {object} params
 * @param {string} params.message 用户问题
 * @param {string} params.sourceType 数据来源: article, image, all
 * @param {number} params.limit 返回数量
 * @param {number} params.similarityThreshold 相似度阈值
 * @param {string} params.conversationId 对话ID
 * @returns {{ answer: string, results: RagSearchResult[] }}
 */
export const ragChatWithResults = (params) => {
  return $https.post('/ai/rag/chat/withResults', params)
}

/**
 * RAG 搜索
 * @param {object} params
 * @param {string} params.keyword 搜索关键词
 * @param {string} params.sourceType 数据来源: article, image, all
 * @param {number} params.limit 返回数量
 */
export const ragSearch = (params) => {
  return $https.get('/ai/rag/search', params)
}

/**
 * RAG 服务状态检查
 */
export const ragStatus = () => {
  return $https.get('/ai/rag/status')
}
